import React, { useState } from 'react'
import { MessengerChat } from "react-messenger-chat-plugin";
import { useSelector } from 'react-redux'

import { ProductCardStock } from '../admin/panelComponents/productsPanel/ProductCardStock'
import { ProductUndefinedScreen } from '../admin/panelComponents/productsPanel/ProductUndefinedScreen'
import { Spin } from '../admin/panelComponents/productsPanel/Spin'
// import { Banner } from '../ui/Banner'
import { Carrousel } from '../ui/Carrousel'
import { Search } from '../ui/Search'
// import tt from '../assets/tt.png'


export const MainScreen = () => {

  const { productsDB } = useSelector( state => state )
  const [search, setSearch] = useState('')
  const [currentSelected, setcurrentSelected] = useState('all')
  const [currentPage, setCurrentPage] = useState(0)
  const [pagina, setPagina] = useState(1)
  const [order, setOrder] = useState("")

  const destacados = productsDB.filter(prod => prod.destacado === true)
  const ofertas = productsDB.filter(prod => prod.oferta > 0)


  const [ navSelected, setNavSelected ] = useState(false)
  const handleSelected = () => {
    setNavSelected( !navSelected )
    setCurrentPage(0)
    setPagina(1)
  }

  const handleSelect = ( select ) => {
    setSearch('')
    setcurrentSelected(select)
    setNavSelected(false)
    setCurrentPage(0)
    setPagina(1)
  }

  const handleOrder = (e) => {
    setOrder(e)
  }

  let dataSelected = []
  if( currentSelected !== 'all' && currentSelected !== 'otros'){
    
    dataSelected =  productsDB.filter( itemFiltrado => itemFiltrado.type.toUpperCase().includes( currentSelected.toUpperCase() ) )
    
  }else if(currentSelected === 'otros'){
    dataSelected = productsDB.filter( itemFiltrado => 
      
      itemFiltrado.type.includes( "Coleccionable" ) ||
      itemFiltrado.type.includes( "Agente" ) ||
      itemFiltrado.type.includes( "Pegatina" ) ||
      itemFiltrado.type.includes( "Grafiti" ) ||
      itemFiltrado.type.includes( "Kit" ) ||
      itemFiltrado.type.includes( "Contenedor" ) 
      
      )
      
    }else{
 
      dataSelected = productsDB
    }
    
  const dataFiltered = productsDB.filter( itemFiltrado => itemFiltrado.nombre.toUpperCase().includes( search.toUpperCase() ) )

  const Product = () =>{

    // setcurrentSelected('all')
    if ( search.length >=1){
      return dataFiltered
    }else{
      return dataSelected
    }

  }



  let productsSend = Product()
  

const productsSendSort = (order) =>{

  switch (order) {
    case "A":
      productsSend.sort((x, y) =>{
        
        if (x.nombre < y.nombre) {return -1;}
        if (x.nombre > y.nombre) {return 1;}
        return 0;
    })
    break
    case "Z":
      productsSend.sort((x, y) =>{
        
        if (x.nombre < y.nombre) {return 1;}
        if (x.nombre > y.nombre) {return -1;}
        return 0;
    })
    break
    case "Mayor":
      productsSend.sort((x, y) =>{
        
        if (x.precio < y.precio) {return 1;}
        if (x.precio > y.precio) {return -1;}
        return 0;
    })
    break
    case "Menor":
      productsSend.sort((x, y) =>{
              
        if (x.precio < y.precio) {return -1;}
        if (x.precio > y.precio) {return 1;}
        return 0;
    })

      break
    case "":
      productsSend.sort((x, y) =>{
              
        if (x.id < y.id) {return 1;}
        if (x.id > y.id) {return -1;}
        return 0;
    })
    default:
      return productsSend
  }

}

productsSendSort( order )



  const productsPagination = () => {

    
      return productsSend.slice(currentPage, currentPage + 21)

    
  }

  const nextPage = () =>{
    if( productsSend.length > currentPage + 21 ){

      setCurrentPage( currentPage + 21 )
      setPagina(pagina+1)

    }
  }
  const prevPage = () =>{
    if(currentPage > 0){

      setCurrentPage( currentPage - 21 )
      setPagina(pagina-1)
    }
  }

  const totalPag = Math.ceil(productsSend.length / 21) 



  console.log(order)
  return (
    <div className=' _main '>

      
        {/* <Banner /> */}

     
      
      <div className=" menu col-12 mt-3 container">
        

        <div className='col-12 NavSkins '>

    
            <ul className={ navSelected ? "col-10 ul activeNav" : "col-10 ul NavSelectSkins "  }>
              <li className='col-2 select-skin' onClick={() => handleSelect('all')}>Todos los skins</li>
              <li className='col-1 select-skin' onClick={() => handleSelect('Pistol')}>Pistolas</li>
              <li className='col-1 select-skin' onClick={() => handleSelect('Escopeta')}>Escopetas</li>
              <li className='col-1 select-skin' onClick={() => handleSelect('Subfusil')}>Subfusiles</li>
              <li className='col-1 select-skin' onClick={() => handleSelect('Rifle')}>Rifles</li>
              <li className='col-1 select-skin' onClick={() => handleSelect('Guantes')}>Guantes</li>
              <li className='col-1 select-skin' onClick={() => handleSelect('Cuchillo')}>Cuchillos</li>
              <li className='col-1 select-skin' onClick={() => handleSelect('otros')}>otros</li>
            </ul>

            <div className='col-12 col-sm-2 menu-options'>

                <div className='col-10 col-lg-12 searchBox'>

									<Search search={ search } setSearch={ setSearch } setcurrentSelected={setcurrentSelected}/>
                </div>

                <div className="oreder-menu ">
                    <div 
                      className="dropdown" 
                      type="button" 
                      id="dropdownoreder" 
                      data-bs-toggle="dropdown" 
                      aria-expanded="false"
                    >
                        <i className="fa-solid fa-arrow-down-wide-short"></i>
                    </div>

                        <ul className="dropdown-menu"   aria-labelledby="dropdownoreder">
                          <li className='nav-menu-items' onClick={() => handleOrder('Mayor')}>Precio: Mayor a menor</li>
                          <li className='nav-menu-items' onClick={() => handleOrder('Menor')}>Precio: Menor a mayor</li>
                          <li className='nav-menu-items' onClick={() => handleOrder('A')}>Orden: A-Z </li>
                          <li className='nav-menu-items' onClick={() => handleOrder('Z')}>Orden: Z-A </li>
                          <li className='nav-menu-items' onClick={() => handleOrder('')}>Sin filtros</li>
                        </ul>
                </div>

             
                <i
                                    
                    alt="Menú"
                    className={
                      navSelected
                        ? "fas fa-times burger-nav "
                        : "fas fa-bars burger-nav "
                    }
                    onClick={handleSelected}
                ></i>
            </div>


        </div>

 
        



        {/* <div className=' col-3'>
          <Select currentSelected={ currentSelected }  setcurrentSelected={ setcurrentSelected } />
        </div> */}

      </div>



      

        { (productsDB.length <=0 )
          ?
        
              <div className='spin'>
                  <Spin />
               
              </div>
          :

        <section className="_productCardStock  container">
          { (Product().length >=1)
              ?
              productsPagination().map(product =>
                    (product.sell !== true && product.sell !== "true")&&
                    <ProductCardStock key={product.id} item={product} />

                  )
              :

              <ProductUndefinedScreen/>

          }

        </section>

        }
       


    

       
        {totalPag > 1 &&
          
          <div className=' text-center pagination container'>
            {
              (currentPage > 0)&&

                <div 
                
                  onClick={prevPage}
                >
                  <i class="fa-solid fa-circle-chevron-left pageSelect"></i>
                </div>
            }

            <div className='text-center'>
              Pag {pagina} / {totalPag}
            </div>

            {(productsSend.length > currentPage + 21 )&&
            
                <div 
                  className=' '
                  onClick={ nextPage }
                >
                  <i className="fa-solid fa-circle-chevron-right  pageSelect"></i>
                </div>
            }


          </div>
        
        }
      {ofertas.length>=1 &&
        
        <div className='mt-5  container-fluid _carrousel-container _carrousel-container-ofertas '>
{/* <img className='ttQW' src={tt} alt="" /> */}
            <Carrousel productos={ofertas} title={"Ofertas"}/>

         
        </div>
      }
        {destacados.length>=1 &&
        <div className='container-fluid _carrousel-container _carrousel-container-destacado'>

          <Carrousel productos={destacados} title={"Destacados"}/>
        </div>
        }


<MessengerChat
    pageId="102599002482960"
    language="es_ES"
    themeColor={"#0080f7"}
    bottomSpacing={10}
    leftSpacing={30}
    loggedInGreeting="Gracias por visitarnos!!! cualquier consulta podes enviarnos un mensaje!"
    greetingDialogDelay={0}
    loggedOutGreeting="loggedOutGreeting"
    greetingDialogDisplay={"icon"}
    debugMode={true}
    onMessengerShow={() => {
      console.log("onMessengerShow");
    }}
    onMessengerHide={() => {
      console.log("onMessengerHide");
    }}
    onMessengerDialogShow={() => {
      console.log("onMessengerDialogShow");
    }}
    onMessengerDialogHide={() => {
      console.log("onMessengerDialogHide");
    }}
    onMessengerMounted={() => {
      console.log("onMessengerMounted");
    }}
    onMessengerLoad={() => {
      console.log("onMessengerLoad");
    }}
  />


    
    </div>
  )
}
